import Vue from 'vue';
import Router from 'vue-router';

Vue.use (Router);

export default new Router ({
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {path: '/', redirect: '/eng/landing'},
    {path: '/:lang', redirect: '/:lang/landing'},
    // {path: '/', name: 'wip', component: () => import ('./views/Wip.vue')},
    {
      path: '/:lang/landing',
      name: 'landing',
      component: () => import ('./views/Landing.vue'),
      beforeEnter: (to, from, next) => {
        //store goback route in localstorage
        localStorage.setItem ('LS_ROUTE_KEY', to.path);
        next ();
      },
    },
    {
      path: '/:lang/about',
      name: 'about',
      component: () => import ('./views/About.vue'),
    },
    {
      path: '/:lang/tutorial',
      name: 'tutorial',
      component: () => import ('./views/Tutorial.vue'),
    },
    {
      path: '/:lang/upload',
      name: 'upload',
      component: () => import('./views/Upload-v2.vue'),
    },
    {
      path: '/:lang/viz',
      name: 'viz',
      component: () => import ('./views/Viz.vue'),
      beforeEnter: (to, from, next) => {
        //store goback route in localstorage
        localStorage.setItem ('LS_ROUTE_KEY', to.path);
        next ();
      },
    },
    // {
    //   path: '/:lang/test',
    //   name: 'test',
    //   component: () => import ('./views/TestPage.vue'),
    // },
  ],
});
